"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReplaceShoppingBagItemErrorResponse = exports.ReplaceShoppingBagItemFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'replace-shopping-bag-item-failed';
const ReplaceShoppingBagItemFailedEvent = exports.ReplaceShoppingBagItemFailedEvent = Name;
const isReplaceShoppingBagItemErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isReplaceShoppingBagItemErrorResponse = isReplaceShoppingBagItemErrorResponse;
